import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { MultiSelect } from 'primereact/multiselect'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Paginator } from 'primereact/paginator'
import { Sidebar } from 'primereact/sidebar'
import { Toast } from 'primereact/toast'
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import Store from 'store'
import CreateLeadDrawer from './CreateLeadDrawer'
import './Homepage.scss'
import UploadCSVDrawer from './UploadCSVDrawer'
import { getImage } from './utils/image'
import { getLeadStatus } from './utils/lead'
import { IUserRow } from './utils/types'
import CopyableUuidBodyWrapper from './components/ColumnWIthCopyOption'
import { CountriesListKeys, CountriesListValues } from './utils/interfaces & enums/country'
import { Tag } from 'primereact/tag'
import { formatToDate } from './utils/helpers'
import Flag from 'react-flagkit'
import { useNavigate } from 'react-router-dom'

interface IHomePageProps {
  setIsLogin: Dispatch<SetStateAction<boolean>>
  dataSource: IUserRow | undefined
  leadsFetching: boolean
  leadsLoading: boolean
  refetchLeads: () => void
  lazyParams: any
  setLazyParams: any
  isLoggedIn: boolean
  isAuthorized: string
}

// const filterLocal = localFilter.filters
const HomePage: React.FC<IHomePageProps> = (props: IHomePageProps) => {
  const {
    setIsLogin,
    dataSource,
    leadsFetching,
    leadsLoading,
    refetchLeads,
    lazyParams,
    setLazyParams,
    isLoggedIn,
    isAuthorized,
  } = props
  const op = useRef<any>(null)
  const tableRef = useRef<any>(null)
  const accessToken = Store.get('aff-tok')

  // const fNameRef = useRef<any>(null)
  const [filterValues, setFilterValues] = useState({
    firstFtdDate: '',
    lastNoteDate: '',
    lastTransactionDate: '',
  })
  const [dateFilter, setDateFilter] = useState<any>(null)

  const [isSidebarVisible, setIsSidebarVisible] = useState<boolean>(false)
  const [csvVisible, setCsvVisible] = useState<boolean>(false)
  const createToast = useRef<any>()
  const [selectedStatus, setSelectedStatus] = useState<any>(null)
  const [globalFilter, setGlobalFilter] = useState('')
  const [selectedCountry, setSelectedCountry] = useState<any>(null)

  const showResponse = (msg: string, isError: boolean) => {
    createToast.current.show({
      severity: `${isError ? 'error' : 'success'}`,
      summary: msg,
      life: 5000,
    })
    !isError && setIsSidebarVisible(false)
  }

  const { data } = useQuery(['lead-status', accessToken], () => getLeadStatus(accessToken), {
    refetchOnWindowFocus: false,
    notifyOnStatusChange: true,
    enabled: isLoggedIn && !!isAuthorized,
  })

  const leadStatus = data?.map((item) => item.status)
  // Query for the REST affiliate Leads

  // to disable input when refetching
  window.onkeydown = (e) => {
    if (leadsFetching || leadsLoading) return false
  }

  useEffect(() => {
    // if pageSize/filter changes reset page number to 1
    if (lazyParams.page !== 0) {
      setLazyParams({ ...lazyParams, page: 0 })
    } else {
      refetchLeads()
    }
  }, [lazyParams.filters]) // eslint-disable-line react-hooks/exhaustive-deps

  // refetch with filters/pagination/sorting
  useEffect(() => {
    refetchLeads()
  }, [lazyParams.page, lazyParams.filters, lazyParams.sortOrder, lazyParams.sortField]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // check if your localstorage exist
    if (Store.get('filters')) {
      setLazyParams(Store.get('filters'))
    }
  }, [setLazyParams])

  const logoutFunc = () => {
    // logout
    Store.clearAll()
    // make api request
    setIsLogin(false)
    window.location.reload()
  }

  const renderHeader = () => {
    return (
      <div className="p-d-flex p-jc-between">
        <span className="list-of-lead">List of Leads</span>
        {Store.get('filters') && (
          <Button
            label="Clear Filters"
            onClick={() => {
              Store.remove('filters')
              setLazyParams({
                first: 0,
                rows: 100,
                page: 0,
              })
              setGlobalFilter('')
              setDateFilter('')
            }}
          />
        )}
        {/* {window.location.reload(false)} */}
      </div>
    )
  }
  const onDateFilterChange = (key: string, value: any) => {
    if (value !== null) tableRef.current.filter(formatDate(value), key, 'equals')
    if (['createdAt', 'firstTransactionsAggregatedData.ftdDate'].includes(key)) setDateFilter(value)
    else setFilterValues((prev) => ({ ...prev, [key]: value }))
  }

  const onPage = (event: any) => {
    let lazyParam = { ...lazyParams, ...event }
    setLazyParams(lazyParam)
    Store.set('filters', lazyParam)
  }

  const onSort = (event: any) => {
    let lazyParam = { ...lazyParams, ...event }
    setLazyParams(lazyParam)
  }

  const onFilter = (event: any) => {
    let lazyParam = { ...lazyParams, ...event }
    lazyParam['first'] = 0
    setLazyParams(lazyParam)

    if (Object.keys(lazyParam['filters']).length > 0) Store.set('filters', lazyParam)
    else Store.remove('filters')
  }

  const formatDate = (dateStr: string[]) => {
    let dateFormat = ''
    if (typeof dateStr === 'string') {
      const date = new Date(dateStr)
      let month: any = date.getMonth() + 1
      let day: any = date.getDate()

      if (month < 10) {
        month = '0' + month
      }

      if (day < 10) {
        day = '0' + day
      }

      dateFormat += day + '-' + month + '-' + date.getFullYear()
    } else {
      if (dateStr?.[0]) {
        const date = new Date(dateStr[0])
        let month: any = date.getMonth() + 1
        let day: any = date.getDate()

        if (month < 10) {
          month = '0' + month
        }

        if (day < 10) {
          day = '0' + day
        }

        dateFormat += day + '-' + month + '-' + date.getFullYear()
      }
      if (dateStr?.[1]) {
        const date = new Date(dateStr[1])
        let month: any = date.getMonth() + 1
        let day: any = date.getDate()

        if (month < 10) {
          month = '0' + month
        }

        if (day < 10) {
          day = '0' + day
        }

        dateFormat += '/' + day + '-' + month + '-' + date.getFullYear()
      }
    }
    return dateFormat
  }

  const renderDateFilter = (field: string) => {
    return (
      <Calendar
        style={{ width: '180px' }}
        selectionMode="range"
        value={dateFilter}
        onChange={(e) => onDateFilterChange(field, e.target.value)}
        placeholder="Search by Date"
        dateFormat="dd-mm-yy"
        className="p-column-filter"
      />
    )
  }
  const dateBodyTemplate = (timeField: string) => {
    return (
      <React.Fragment>
        <span style={{ width: 300 }}>{timeField ? formatToDate(timeField) : 'N/A'}</span>
      </React.Fragment>
    )
  }

  const ftddateBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <div className="p-grid p-justify-center">
          {rowData?.firstTransactionsAggregatedData?.ftdDate
            ? formatToDate(rowData?.firstTransactionsAggregatedData?.ftdDate)
            : 'N/A'}
        </div>
      </React.Fragment>
    )
  }

  const isFtdTransactionBodyTemplate = (rowData: any) => {
    const hasFtdData = !!rowData?.firstTransactionsAggregatedData?.ftdDate

    return (
      <div className="p-grid p-justify-center" style={{ width: 100 }}>
        <Tag
          icon={hasFtdData ? 'pi pi-check' : 'pi pi-times'}
          severity={hasFtdData ? 'success' : 'danger'}
          style={{ minWidth: '40px', textAlign: 'center' }}
        />
      </div>
    )
  }

  const renderLtdDateFilter = () => {
    return (
      <Calendar
        style={{ width: '180px' }}
        selectionMode="range"
        value={new Date(filterValues['lastTransactionDate'])}
        onChange={(e) => onDateFilterChange('lastTransactionDate', e.target.value)}
        placeholder="Search by Date"
        dateFormat="dd-mm-yy"
        className="p-column-filter"
      />
    )
  }
  const ltddateBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <div className="p-grid p-justify-center">{rowData?.lastTransactionDate ? formatDate(rowData?.lastTransactionDate) : 'N/A'}</div>
      </React.Fragment>
    )
  }

  const renderNoteDateFilter = () => {
    return (
      <Calendar
        style={{ width: '180px' }}
        selectionMode="range"
        value={new Date(filterValues['lastNoteDate'])}
        onChange={(e) => onDateFilterChange('lastNoteDate', e.target.value)}
        placeholder="Search by Date"
        dateFormat="dd-mm-yy"
        className="p-column-filter"
      />
    )
  }
  const notedateBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <div className="p-grid p-justify-center">
          {formatDate(rowData?.notesAggregatedData?.lastNoteDate)}
        </div>
      </React.Fragment>
    )
  }

  const renderCountry = (rowData: any) => {
    const countryCode = rowData.country
    const countryName =
      CountriesListKeys[countryCode as keyof typeof CountriesListKeys] || countryCode

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {countryCode && (
          <span style={{ marginRight: '8px' }}>
            <Flag country={countryCode} size={20} aria-hidden="true" />
          </span>
        )}
        <span>{countryName}</span>
      </div>
    )
  }

  const renderLeadStatusFilter = () => {
    // Ensure selectedStatus is at least an empty array or null
    const safeSelectedStatus = selectedStatus || null

    // Ensure leadStatus is at least an empty array
    const safeLeadStatus = Array.isArray(leadStatus) ? leadStatus : []

    return (
      <MultiSelect
        value={safeSelectedStatus}
        options={safeLeadStatus}
        onChange={onStatusFilterChange}
        showClear
        placeholder="Select a Status"
        className="p__column__filter"
      />
    )
  }

  const countryListFilter = () => {
    // Ensure selectedCountry is at least an empty array or null
    const safeSelectedCountry = selectedCountry || null

    return (
      <MultiSelect
        value={safeSelectedCountry}
        options={Object.entries(CountriesListValues).map(([label, value]) => ({
          label: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span style={{ marginRight: '8px' }}>
                <Flag country={value} size={20} aria-hidden="true" />
              </span>
              <span>{label}</span>
            </div>
          ),
          value,
        }))}
        onChange={onCountryFilterChange}
        showClear
        placeholder="Select a Country"
        className="p__column__filter"
      />
    )
  }

  const onStatusFilterChange = (event: any) => {
    tableRef.current.filter(event.value, 'userStatus.status', 'equals')
    setSelectedStatus(event.value)
  }

  const onCountryFilterChange = (event: any) => {
    tableRef.current.filter(event.value, 'country', 'in')
    setSelectedCountry(event.value)
  }

  const header = renderHeader()
  const ltdDateFilter = renderLtdDateFilter()
  const noteDateFilter = renderNoteDateFilter()
  const leadStatusFilter = renderLeadStatusFilter()
  const documents = dataSource?.data?.find((item) => item?.documents?.length)
  const accounts = dataSource?.data?.find((item) => item?.accounts?.length)
  const devices = dataSource?.data?.find((item) => item?.devices?.length)
  const notes = dataSource?.data?.find((item) => item?.notesAggregatedData)
  const depositData = dataSource?.data?.find((item) => item?.aggregatedData)
  const accountSumData = dataSource?.data?.find((item) => item?.accountSumAggregatedData)
  const ftdDateData = dataSource?.data?.find((item) => item?.firstTransactionsAggregatedData)
  const lastTransactionsData = dataSource?.data?.find((item) => item?.lastTransactionsAggregatedData)
  const hasUserStatus = dataSource?.data?.find((item) => item?.userStatus)?.userStatus
  const countryFilter = countryListFilter()

  let accountsColumns: string[] = []
  if (accounts) accountsColumns = Object.keys(accounts?.accounts?.[0])
  let devicesColumns: string[] = []
  if (devices) devicesColumns = Object.keys(devices?.devices?.[0])
  let documentColumns: string[] = []
  if (documents) documentColumns = Object.keys(documents?.documents?.[0])
  let noteColumns: string[] = []
  if (notes) noteColumns = Object.keys(notes?.notesAggregatedData)
  let depositColumns: string[] = []
  if (depositData) depositColumns = Object.keys(depositData?.aggregatedData)
  let ftdDateColumns: string[] = []
  if (ftdDateData) ftdDateColumns = Object.keys(ftdDateData?.firstTransactionsAggregatedData)
  let accountSumColumns: string[] = []
  if (accountSumData) accountSumColumns = Object.keys(accountSumData?.accountSumAggregatedData)
  let lastTransactionsColumns: string[] = []
  if (lastTransactionsData) lastTransactionsColumns = Object.keys(lastTransactionsData?.lastTransactionsAggregatedData)
  const currentPage = lazyParams.page // Current page number
  const rowsPerPage = lazyParams.rows

  const startIndex = currentPage * rowsPerPage // Starting index of the current page
  const endIndex = startIndex + rowsPerPage

  const currentPageData = dataSource?.data?.slice(startIndex, endIndex)

  const totalFtdAmount = currentPageData?.reduce((acc, obj) => {
    return acc + obj.totalFtdAmount
  }, 0)

  const displayedAmount =
    dataSource?.totalFtdAmount === 0 ? dataSource?.totalFtdAmount : totalFtdAmount

  const renderFTDfooter = () => {
    return (
      <div className="p-grid p-justify-center" style={{ position: 'relative' }}>
        Total FTD Amount: ${displayedAmount?.toFixed(2) || 'N/A'}
      </div>
    )
  }

  const navigate = useNavigate()

  return (
    <div className="page__container">
      <Toast ref={createToast} />
      <div className="topbar p-grid p-justify-between p-align-center p-shadow-4">
        <div className="brand__options p-grid  p-align-center p-ml-3">
          <img src={getImage('brand-logo.jpg')} alt="brand logo" />
          <span
            className="brand__name cursor-pointer"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            Affiliate Report
          </span>
          <Button
            className="topbar__btn p-ml-2"
            icon="pi pi-plus-circle"
            onClick={() => setIsSidebarVisible(true)}
          >
            <span className="p-px-3">CREATE LEAD</span>
          </Button>
          <Button
            onClick={() => setCsvVisible(true)}
            className="topbar__btn p-ml-2"
            icon="pi pi-upload"
          >
            <span className="p-px-3">IMPORT CSV</span>
          </Button>
        </div>
        {leadsFetching || leadsLoading ? (
          <div>Loading....</div>
        ) : (
          <div className="p-grid p-align-center p-mr-3  language__options">
            <span
              style={{
                display: 'inline-block',
                marginLeft: 24,
                marginRight: 8,
                fontWeight: 500,
                color: '#1976d2',
                cursor: 'pointer',
                fontSize: 15,
              }}
              onClick={() => navigate('/support-tickets')}
            >
              Support Tickets
            </span>

            <span style={{ marginLeft: 8, marginRight: 8 }}> | </span>
            {Store.get('aff-name') || 'Anonymous'}
            <OverlayPanel className="ui-overlaypanel" ref={op} dismissable>
              <span onClick={logoutFunc} style={{ display: 'block', cursor: 'pointer' }}>
                Logout
              </span>
            </OverlayPanel>
            <i className="pi pi-chevron-down p-ml-3" onClick={(e) => op.current.toggle(e)}></i>
          </div>
        )}
      </div>
      <div className="card table__container p-shadow-10">
        {leadsFetching || leadsLoading ? (
          <div>Loading....</div>
        ) : (
          <div className="total__leads p-grid p-align-center p-justify-between ">
            <span className="p-ml-3">Total Leads : {`${dataSource ? dataSource.total : 0}`}</span>
          </div>
        )}

        <div className="leads__table p-mt-4">
          <DataTable
            autoLayout
            header={header}
            dataKey="id"
            rowHover
            lazy
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={dataSource && dataSource.total}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            onFilter={onFilter}
            filters={lazyParams.filters}
            ref={tableRef}
            loading={leadsFetching || leadsLoading}
            value={(dataSource && dataSource.data) || []}
            emptyMessage="No Leads found"
            //@ts-ignore
            responsiveLayout="scroll"
            scrollHeight="200px"
            columnResizeMode="fit"
            globalFilter={globalFilter}
            // footer={renderFTDfooter}
          >
            <Column
              style={{ width: '12%' }}
              field="id"
              header="Lead ID"
              sortable
              key="leadId"
              filter
              body={(rowData) => <CopyableUuidBodyWrapper rowData={rowData} keyIndex={'id'} />}
              bodyStyle={{ ellipsis: true }}
              filterFunction={onFilter}
              filterPlaceholder="Search by ID"
            />
            <Column
              style={{ width: '12%' }}
              field="shortId"
              header="Short ID"
              sortable
              key="shortId"
              filter
              body={(rowData) => <CopyableUuidBodyWrapper rowData={rowData} keyIndex={'shortId'} />}
              bodyStyle={{ ellipsis: true }}
              filterFunction={onFilter}
              filterPlaceholder="Search by ID"
            />
            {dataSource?.data?.[0]?.createdAt && <Column
              style={{ width: '15%' }}
              field="createdAt"
              header="Time"
              body={(rowData) => dateBodyTemplate(rowData?.createdAt)}
              sortable
              key="registrationDate"
              filter
              filterMatchMode="custom"
              filterElement={renderDateFilter('createdAt')}
              filterPlaceholder="Search by Date"
            />}
            {dataSource?.data?.[0]?.updatedAt && <Column
              style={{ width: '15%' }}
              field="updatedAt"
              header="Updated Time"
              body={(rowData) => dateBodyTemplate(rowData.updatedAt)}
              sortable
              key="updatedAtDate"
              filter
              filterMatchMode="custom"
              filterElement={renderDateFilter('updatedAt')}
              filterPlaceholder="Search by Date"
            />}

            <Column
              style={{ width: '12%' }}
              field="tags"
              header="Tags"
              sortField="tags.value"
              filterField="tags.value"
              sortable
              filter
              body={(rowData) => (
                <span>
                  {rowData?.tags?.map((c: any, i: number) => `${i !== 0 ? ',' : ''}${c.value}`)}
                </span>
              )}
              filterPlaceholder="Search by Tags"
            />
            {dataSource?.data?.[0]?.firstName && < Column
              style={{ width: '12%' }}
              field="firstName"
              header="Name"
              sortable
              filter
              filterPlaceholder="Search by firstName"
            />}
            {dataSource?.data?.[0]?.lastName && <Column
              style={{ width: '12%' }}
              field="lastName"
              header="Surname"
              sortable
              filter
              filterPlaceholder="Search by lastName"
            />}
            {dataSource?.data?.[0]?.affiliateUser && <Column
              style={{ width: '12%' }}
              field="affiliateUser.name"
              header="Affiliate User"
              sortable
              filter
              filterPlaceholder="Search by Affiliate User"
            />}
            <Column
              style={{ width: '12%' }}
              field="country"
              header="Country"
              body={renderCountry}
              sortable
              filter
              filterElement={countryFilter}
              filterPlaceholder="Search by Country"
            />
            {depositColumns?.includes('ftdAmount') && (
              <Column
                style={{ width: '12%' }}
                field="aggregatedData.ftdAmount"
                key="aggregatedData.ftdAmount"
                header="FTD Amount"
                sortable
                filter
                filterPlaceholder="Search by FTD Amount"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.aggregatedData?.ftdAmount > 0
                      ? parseFloat(rowData?.aggregatedData?.ftdAmount).toFixed(2)
                      : 'N/A'}
                  </div>
                )}
                footer={renderFTDfooter}
              />
            )}
            {ftdDateColumns?.includes('ftdDate') && (
              <Column
                style={{ width: '12%' }}
                field="firstTransactionsAggregatedData.ftdDate"
                header="FTD Date"
                body={ftddateBodyTemplate}
                filter
                key="firstTransactionsAggregatedData.ftdDate"
                filterMatchMode="custom"
                sortable
                filterElement={renderDateFilter('firstTransactionsAggregatedData.ftdDate')}
                filterPlaceholder="Search by Date"
              />
            )}
            {ftdDateColumns?.includes('ftdDate') && (
              <Column
                style={{ width: '25%' }}
                field="firstTransactionsAggregatedData.ftdDate"
                header="Is FTD"
                body={isFtdTransactionBodyTemplate}
                key="ftd"
                filterMatchMode="custom"
              />
            )}
            <Column
              style={{ width: '12%' }}
              field="email"
              header="Email"
              sortable
              filter
              filterPlaceholder="Search by email"
            />
            {hasUserStatus && (
              <Column
                style={{ width: '12%' }}
                field="userStatus"
                header="Lead Status"
                sortable
                filter
                filterElement={leadStatusFilter}
                filterPlaceholder="Search by lead Status"
                body={(rowData) => <span>{rowData?.userStatus?.status}</span>}
              />
            )}

            {depositColumns?.includes('sumDeposit') && (
              <Column
                style={{ width: '12%' }}
                field="aggregatedData.sumDeposit"
                header="Total Deposit"
                sortable
                filter
                filterPlaceholder="Search by sum deposit"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.aggregatedData?.sumDeposit
                      ? parseFloat(rowData?.aggregatedData?.sumDeposit).toFixed(2)
                      : 'N/A'}
                  </div>
                )}
              />
            )}
            {depositColumns?.includes('netDeposit') && (
              <Column
                style={{ width: '12%' }}
                field="aggregatedData.netDeposit"
                header="Net Deposit"
                sortable
                filter
                filterPlaceholder="Search by net deposit"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.aggregatedData?.netDeposit
                      ? parseFloat(rowData?.aggregatedData?.netDeposit).toFixed(2)
                      : 'N/A'}
                  </div>
                )}
              />
            )}
            {dataSource?.data?.[0]?.isQualified === true &&
              dataSource?.data?.[0]?.transactionsVolume && (
                <Column
                  style={{ width: '12%' }}
                  field="transactionsVolume"
                  header="Transaction Volume"
                  sortable
                  filter
                  filterPlaceholder="Search by Transaction Volume"
                />
              )}
            {dataSource?.data?.[0]?.isQualified === true &&
              dataSource?.data?.[0]?.lastTransactionDate && (
                <Column
                  style={{ width: '12%' }}
                  field="lastTransactionDate"
                  header="LTD"
                  body={ltddateBodyTemplate}
                  filter
                  sortable
                  filterElement={ltdDateFilter}
                  filterPlaceholder="Search by Date"
                />
              )}
            {accountsColumns?.includes('marginFree') && (
              <Column
                style={{ width: '12%' }}
                field="account.marginFree"
                header="Free Margin"
                sortable
                filter
                filterPlaceholder="Search by Free Margin"
                body={(rowData) =>
                  rowData?.accounts
                    ?.map((account: any) => account?.marginFree)
                    .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                    .toFixed(2)
                }
              />
            )}
            {accountsColumns.includes('margin') && (
              <Column
                style={{ width: '12%' }}
                field="account.margin"
                header="Margin"
                filter
                sortable
                filterPlaceholder="Search by Margin"
                body={(rowData) =>
                  rowData?.accounts
                    ?.map((account: any) => account?.margin)
                    .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                    .toFixed(2)
                }
              />
            )}
            {noteColumns?.includes('lastNoteDate') && (
              <Column
                style={{ width: '12%' }}
                field="notesAggregatedData.lastNoteDate"
                header="Note Date"
                body={notedateBodyTemplate}
                filter
                sortable
                filterElement={noteDateFilter}
                filterPlaceholder="Search by Date"
              />
            )}
            {noteColumns?.includes('totalNotes') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="notesAggregatedData.totalNotes"
                header="Total Notes"
                sortable
                body={(rowData) => <span>{rowData?.notesAggregatedData?.totalNotes || 'N/A'}</span>}
              />
            )}
            {noteColumns?.includes('lastNote') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="notesAggregatedData.lastNote"
                header="Last Note"
                sortable
                body={(rowData) => <span>{rowData?.notesAggregatedData?.lastNote || 'N/A'}</span>}
              />
            )}
            {noteColumns?.includes('type') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="notesAggregatedData.type"
                header="Note Type"
                sortable
                body={(rowData) => <span>{rowData?.notesAggregatedData?.type || 'N/A'}</span>}
              />
            )}
            {accountsColumns.includes('equity') && (
              <Column
                style={{ width: '12%' }}
                field="accounts.equity"
                header="Equity"
                sortable
                filter
                filterPlaceholder="Search by Equity"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.accounts
                      ?.map((account: any) => account?.equity)
                      .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                      .toFixed(2)}
                  </div>
                )}
              />
            )}
            {accountsColumns.includes('balance') && (
              <Column
                style={{ width: '12%' }}
                field="accounts.balance"
                header="Balance"
                sortable
                filter
                filterPlaceholder="Search by Balance"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.accounts
                      ?.map((account: any) => account?.balance)
                      .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                      .toFixed(2)}
                  </div>
                )}
              />
            )}

            {accountsColumns.includes('credit') && (
              <Column
                style={{ width: '12%' }}
                field="accounts.credit"
                header="Credit"
                sortable
                filter
                filterPlaceholder="Search by Credit"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.accounts
                      ?.map((account: any) => account?.credit)
                      .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                      .toFixed(2)}
                  </div>
                )}
              />
            )}

            {/* {accountsColumns.includes('balance') && (
              <Column
                style={{ width: '12%' }}
                field="balance"
                header="Amount"
                sortable
                filter
                filterPlaceholder="Search by Amount"
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {rowData?.accounts
                      .map((account: any) => account?.balance)
                      .reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr), 0)
                      .toFixed(2)}
                  </div>
                )}
              />
            )} */}

            {documentColumns?.includes('url') && (
              <Column
                style={{ minWidth: '200px' }}
                field="url"
                header="KYC"
                sortable
                body={(rowData) => (
                  <div className="p-grid p-justify-center">
                    {!rowData?.documents?.length ? (
                      <i className="pi pi-times" style={{ fontSize: '2em', color: 'red' }}></i>
                    ) : (
                      rowData?.documents.find((document: any) => document?.url) && (
                        <i className="pi pi-check" style={{ fontSize: '2em', color: 'green' }}></i>
                      )
                    )}
                  </div>
                )}
              />
            )}
            {dataSource?.data?.[0]?.utmCampaign && (
              <Column
                style={{ width: '12%' }}
                field="utmCampaign"
                header="UTM Campaign"
                key="utmCampaign"
                sortable
                filter
                filterPlaceholder="Search by UTM Campaign"
                body={(rowData) => <span>{rowData?.utmCampaign || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.utmSource && (
              <Column
                style={{ width: '12%' }}
                field="utmSource"
                header="UTM Source"
                key="utmSource"
                sortable
                filter
                filterPlaceholder="Search by UTM Source"
                body={(rowData) => <span>{rowData?.utmSource || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.utmMedium && (
              <Column
                style={{ width: '12%' }}
                field="utmMedium"
                header="UTM Medium"
                key="utmMedium"
                sortable
                filter
                filterPlaceholder="Search by UTM Medium"
                body={(rowData) => <span>{rowData?.utmMedium || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.utmContent && (
              <Column
                style={{ width: '12%' }}
                field="utmContent"
                header="UTM Content"
                key="utmContent"
                sortable
                filter
                filterPlaceholder="Search by UTM Content"
                body={(rowData) => <span>{rowData?.utmContent || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.utmDevice && (
              <Column
                style={{ width: '12%' }}
                field="utmDevice"
                header="UTM Device"
                key="utmDevice"
                sortable
                filter
                filterPlaceholder="Search by UTM Device"
                body={(rowData) => <span>{rowData?.utmDevice || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.utmTerm && (
              <Column
                style={{ width: '12%' }}
                field="utmTerm"
                header="UTM Term"
                key="utmTerm"
                sortable
                filter
                filterPlaceholder="Search by UTM Term"
                body={(rowData) => <span>{rowData?.utmTerm || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.sourceId && (
              <Column
                style={{ width: '12%' }}
                field="sourceId"
                header="Source ID"
                key="sourceId"
                sortable
                filter
                filterPlaceholder="Search by Source ID"
                body={(rowData) => <CopyableUuidBodyWrapper rowData={rowData} keyIndex={'sourceId'} />}
                bodyStyle={{ ellipsis: true }}
              />
            )}
            {dataSource?.data?.[0]?.subAffiliateId && (
              <Column
                style={{ width: '12%' }}
                field="subAffiliateId"
                header="Sub Affiliate ID"
                key="subAffiliateId"
                sortable
                filter
                filterPlaceholder="Search by Sub Affiliate ID"
                body={(rowData) => <CopyableUuidBodyWrapper rowData={rowData} keyIndex={'subAffiliateId'} />}
                bodyStyle={{ ellipsis: true }}
              />
            )}
            {dataSource?.data?.[0]?.description && (
              <Column
                style={{ width: '12%' }}
                field="description"
                header="Description"
                key="description"
                sortable
                filter
                filterPlaceholder="Search by Description"
                body={(rowData) => <span>{rowData?.description || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.funnel && (
              <Column
                style={{ width: '12%' }}
                field="funnel"
                header="Funnel"
                key="funnel"
                sortable
                filter
                filterPlaceholder="Search by Funnel"
                body={(rowData) => <span>{rowData?.funnel || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.brand && (
              <Column
                style={{ width: '12%' }}
                field="brand.name"
                header="Brand"
                key="brand.name"
                sortable
                filter
                filterPlaceholder="Search by Brand"
                body={(rowData) => <span>{rowData?.brand?.name || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.bonusTag && (
              <Column
                style={{ width: '12%' }}
                field="bonusTag.name"
                header="Bonus Tag"
                key="bonusTag.name"
                sortable
                filter
                filterPlaceholder="Search by Bonus Tag"
                body={(rowData) => <span>{rowData?.bonusTag?.name || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.initialRetentionAgent && (
              <Column
                style={{ width: '12%' }}
                field="initialRetentionAgent.fullName"
                header="Initial Retention Agent"
                key="initialRetentionAgent.fullName"
                sortable
                filter
                filterPlaceholder="Search by Initial Retention Agent"
                body={(rowData) => <span>{rowData?.initialRetentionAgent?.fullName || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.lead != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="lead"
                header="Lead"
                key="lead"
                sortable
                body={(rowData) => <span>{rowData?.lead ? 'Yes' : 'No'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.nationalId && (
              <Column
                style={{ width: '12%' }}
                field="nationalId"
                header="National ID"
                key="nationalId"
                sortable
                filter
                filterPlaceholder="Search by National ID"
                body={(rowData) => <CopyableUuidBodyWrapper rowData={rowData} keyIndex={'nationalId'} />}
              />
            )}
            {dataSource?.data?.[0]?.retStatus && (
              <Column
                style={{ width: '12%' }}
                field="retStatus"
                header="Ret Status"
                key="retStatus"
                sortable
                filter
                filterPlaceholder="Search by Ret Status"
                body={(rowData) => <span>{rowData?.retStatus || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.additionalStatus && (
              <Column
                style={{ width: '12%' }}
                field="additionalStatus"
                header="Additional Status"
                key="additionalStatus"
                sortable
                filter
                filterPlaceholder="Search by Additional Status"
                body={(rowData) => <span>{rowData?.additionalStatus || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.openingStatus && (
              <Column
                style={{ width: '12%' }}
                field="openingStatus"
                header="Opening Status"
                key="openingStatus"
                sortable
                filter
                filterPlaceholder="Search by Opening Status"
                body={(rowData) => <span>{rowData?.openingStatus || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.language && (
              <Column
                style={{ width: '12%' }}
                field="language"
                header="Language"
                key="language"
                sortable
                filter
                filterPlaceholder="Search by Language"
                body={(rowData) => <span>{rowData?.language || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.city && (
              <Column
                style={{ width: '12%' }}
                field="city"
                header="City"
                key="city"
                sortable
                filter
                filterPlaceholder="Search by City"
                body={(rowData) => <span>{rowData?.city || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.lastVisit && (
              <Column
                style={{ width: '12%' }}
                field="lastVisit"
                header="Last Visit"
                key="lastVisit"
                sortable
                filter
                filterMatchMode="custom"
                filterElement={renderDateFilter('lastVisit')}
                filterPlaceholder="Search by Date"
                body={(rowData) => rowData?.lastVisit ? dateBodyTemplate(rowData?.lastVisit) : 'N/A'}
              />
            )}
            {lastTransactionsColumns?.includes('ltdAmount') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="lastTransactionsAggregatedData.ltdAmount"
                header="Last Transaction Amount"
                key="lastTransactionsAggregatedData.ltdAmount"
                sortable
                filter
                filterPlaceholder="Search by Last Transaction Amount"
                body={(rowData) => <span>{rowData?.lastTransactionsAggregatedData?.ltdAmount ? parseFloat(rowData?.lastTransactionsAggregatedData?.ltdAmount).toFixed(2) : '0.00'}</span>}
              />
            )}
            {lastTransactionsColumns?.includes('ltdDate') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="lastTransactionsAggregatedData.ltdDate"
                header="Last Transaction Date"
                key="lastTransactionsAggregatedData.ltdDate"
                sortable
                filter
                filterMatchMode="custom"
                filterElement={renderDateFilter('lastTransactionsAggregatedData.ltdDate')}
                filterPlaceholder="Search by Date"
                body={(rowData) => dateBodyTemplate(rowData?.lastTransactionsAggregatedData?.ltdDate)}
              />
            )}
            {dataSource?.data?.[0]?.tpNumberAggregatedData && (
              <Column
                style={{ width: '12%' }}
                field="tpNumberAggregatedData.tpNumberAggList"
                header="TP Number"
                key="tpNumberAggregatedData.tpNumberAggList"
                sortable
                filter
                filterPlaceholder="Search by TP Number"
                body={(rowData) => <span>{rowData?.tpNumberAggregatedData?.tpNumberAggList || 'N/A'}</span>}
              />
            )}
            {accountSumColumns?.includes('sumEquity') && (
              <Column
                style={{ width: '12%' }}
                field="accountSumAggregatedData.sumEquity"
                header="Total Equity"
                key="accountSumAggregatedData.sumEquity"
                sortable
                filter
                filterPlaceholder="Search by Sum Equity"
                body={(rowData) => <span>{rowData?.accountSumAggregatedData?.sumEquity ? parseFloat(rowData?.accountSumAggregatedData?.sumEquity).toFixed(2) : '0.00'}</span>}
              />
            )}
            {accountSumColumns?.includes('sumWithdrawal') && (
              <Column
                style={{ width: '12%' }}
                field="accountSumAggregatedData.sumWithdrawal"
                header="Total Withdrawal"
                key="accountSumAggregatedData.sumWithdrawal"
                sortable
                filter
                filterPlaceholder="Search by Sum Withdrawal"
                body={(rowData) => <span>{rowData?.accountSumAggregatedData?.sumWithdrawal ? parseFloat(rowData?.accountSumAggregatedData?.sumWithdrawal).toFixed(2) : '0.00'}</span>}
              />
            )}
            {accountSumColumns?.includes('sumReDeposit') && (
              <Column
                style={{ width: '12%' }}
                field="accountSumAggregatedData.sumReDeposit"
                header="Re-Deposit"
                key="accountSumAggregatedData.sumReDeposit"
                sortable
                filter
                filterPlaceholder="Search by Sum Re-Deposit"
                body={(rowData) => <span>{rowData?.accountSumAggregatedData?.sumReDeposit ? parseFloat(rowData?.accountSumAggregatedData?.sumReDeposit).toFixed(2) : '0.00'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.userAppCallStatus && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="userAppCallStatus.status"
                header="Call Status"
                key="userAppCallStatus.status"
                body={(rowData) => <span>{rowData?.userAppCallStatus?.status || 'N/A'}</span>}
              />
            )}
            {devicesColumns?.includes('systemName') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="devices.systemName"
                header="Device Type"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Device Type"
                body={(rowData) => <span>{rowData?.devices?.map((device: any) => device?.systemName)?.join(', ') || 'N/A'}</span>}
              />
            )}
            {devicesColumns?.includes('brand') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="devices.brand"
                header="Device Brand"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Device Brand"
                body={(rowData) => <span>{rowData?.devices?.map((device: any) => device?.brand)?.join(', ') || 'N/A'}</span>}
              />
            )}
            {devicesColumns?.includes('model') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="devices.model"
                header="Device Model"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Device Model"
                body={(rowData) => <span>{rowData?.devices?.map((device: any) => device?.model)?.join(', ') || 'N/A'}</span>}
              />
            )}
            {devicesColumns?.includes('version') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="devices.version"
                header="Device Version"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Device Version"
                body={(rowData) => <span>{rowData?.devices?.map((device: any) => device?.version)?.join(', ') || 'N/A'}</span>}
              />
            )}
            {devicesColumns?.includes('lastCountry') && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="devices.lastCountry"
                header="Device Last Country"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Last Country"
                body={(rowData) => <span>{rowData?.devices?.map((device: any) => device?.lastCountry)?.join(', ') || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.hasTelegramAccount != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="hasTelegramAccount"
                header="Has Telegram Account"
                key="hasTelegramAccount"
                body={(rowData) => <span>{rowData?.hasTelegramAccount ? 'Yes' : 'No'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.hasWhatsapp != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="hasWhatsapp"
                header="Has WhatsApp"
                key="hasWhatsapp"
                body={(rowData) => <span>{rowData?.hasWhatsapp ? 'Yes' : 'No'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.coldLead != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="coldLead"
                header="Cold Lead"
                key="coldLead"
                body={(rowData) => <span>{rowData?.coldLead ? 'Yes' : 'No'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.coldLeadSource && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="coldLeadSource"
                header="Cold Lead Source"
                key="coldLeadSource"
                body={(rowData) => <span>{rowData?.coldLeadSource || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.initialLanguage && (
              <Column
                style={{ width: '12%' }}
                field="initialLanguage"
                header="Initial Language"
                key="initialLanguage"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Initial Language"
                body={(rowData) => <span>{rowData?.initialLanguage || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.isPropTradeUser != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="isPropTradeUser"
                header="Is Prop Trade User"
                key="isPropTradeUser"
                body={(rowData) => <span>{rowData?.isPropTradeUser ? 'Yes' : 'No'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.lastVoipCall && (
              <Column
                style={{ width: '12%' }}
                field="lastVoipCall"
                header="Last Voip Call"
                key="lastVoipCall"
                sortable
                filter
                filterMatchMode="custom"
                filterElement={renderDateFilter('lastVoipCall')}
                filterPlaceholder="Search by Date"
                body={(rowData) => rowData?.lastVoipCall ? dateBodyTemplate(rowData?.lastVoipCall) : 'N/A'}
              />
            )}
            {dataSource?.data?.[0]?.lastAppCall && (
              <Column
                style={{ width: '12%' }}
                field="lastAppCall"
                header="Last App Call"
                key="lastAppCall"
                sortable
                filter
                filterMatchMode="custom"
                filterElement={renderDateFilter('lastAppCall')}
                filterPlaceholder="Search by Date"
                body={(rowData) => rowData?.lastAppCall ? dateBodyTemplate(rowData?.lastAppCall) : 'N/A'}
              />
            )}
            {dataSource?.data?.[0]?.sourcePage && (
              <Column
                style={{ width: '12%' }}
                field="sourcePage"
                header="Source Page"
                key="sourcePage"
                sortable
                filter
                filterFunction={onFilter}
                filterPlaceholder="Search by Source Page"
                body={(rowData) => <span>{rowData?.sourcePage || 'N/A'}</span>}
              />
            )}
            {dataSource?.data?.[0]?.userTelegramBotConfig != null && (
              <Column
                style={{ width: '12%', whiteSpace: 'nowrap' }}
                field="userTelegramBotConfig.chatId"
                header="Telegram Bot"
                key="userTelegramBotConfig.chatId"
                body={(rowData) => <span>{rowData?.userTelegramBotConfig?.chatId ? 'Yes' : 'No'}</span>}
              />
            )}
            </DataTable>
        </div>
        <Sidebar
          visible={isSidebarVisible}
          position="right"
          style={{ width: '40rem' }}
          onHide={() => setIsSidebarVisible(false)}
        >
          <CreateLeadDrawer
            showResponse={showResponse}
            toggleSideBar={setIsSidebarVisible}
            refetch={refetchLeads}
          />
        </Sidebar>

        <Sidebar
          visible={csvVisible}
          position="right"
          style={{ width: '40rem' }}
          onHide={() => setCsvVisible(false)}
        >
          <UploadCSVDrawer
            refetch={refetchLeads}
            showResponse={showResponse}
            toggleSideBar={setCsvVisible}
          />
        </Sidebar>
      </div>
      <div className="paginator-demo">
        <div className="card">
          {/* <h5>List of Leads</h5> */}
          <Paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={dataSource && dataSource.total}
            rowsPerPageOptions={[100, 150, 300]}
            onPageChange={onPage}
          ></Paginator>
        </div>
      </div>

      {/* <span>Home Page</span> */}
      {/* <Button onClick={logoutFunc}>Logout</Button> */}
    </div>
  )
}

export default HomePage
